export default __webpack_public_path__ + "static/media/Zugite Sacrificial Poniard.1f85c32a.jpg";